import request from '@/utils/request';

export function addFeedback(data) {
  return request({
    url: `/api/standard/Feedbacks`,
    method: 'post',
    data
  });
}
